module.exports = __webpack_public_path__ + "img/product-placeholder-26.ab9225c.png";